var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5026 15.9193C12.8749 15.9193 16.4193 12.3749 16.4193 8.0026C16.4193 3.63035 12.8749 0.0859375 8.5026 0.0859375C4.13035 0.0859375 0.585938 3.63035 0.585938 8.0026C0.585938 12.3749 4.13035 15.9193 8.5026 15.9193ZM6.73468 6.31288C7.11315 6.53181 7.59743 6.40248 7.81636 6.02401C8.57399 4.92729 10.0385 6.3876 8.83776 7.10141C8.62193 7.22971 8.33969 7.44327 8.12501 7.70489C7.92174 7.95261 7.73505 8.29327 7.71309 8.71196C7.71029 8.73901 7.70886 8.76648 7.70886 8.79427C7.70886 9.2315 8.0633 9.58594 8.50053 9.58594C9.10399 9.58594 9.21886 9.26535 9.33477 8.94183C9.40933 8.73372 9.48433 8.5244 9.6901 8.39844C10.3445 7.99784 10.8776 7.2883 10.8776 6.41927C10.8776 5.10759 9.81428 4.04427 8.5026 4.04427C7.62252 4.04427 6.85528 4.52337 6.44582 5.2312C6.22689 5.60966 6.35622 6.09395 6.73468 6.31288ZM7.70886 11.1693C7.70886 10.732 8.0633 10.3776 8.50053 10.3776C8.93775 10.3776 9.2922 10.732 9.2922 11.1693C9.2922 11.6065 8.93775 11.9609 8.50053 11.9609C8.0633 11.9609 7.70886 11.6065 7.70886 11.1693Z",
    fill: "#393ABD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/question-icon.46058a256bea7807e8909d86e73f5ba2.svg";
export { ForwardRef as ReactComponent };